import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ModuleLayout from '../../layout/ModuleLayout';
import { useTranslation } from 'react-i18next';
import {
  FaBoxes,
  FaWarehouse,
  FaBox,
  FaListAlt,
  FaBalanceScale,
  FaDirections,
  FaBarcode
} from 'react-icons/fa';

// Import components
import ProductList from '../Products/ProductList';
import ProductForm from '../Products/ProductForm';
import CategorieList from '../Products/CategorieList';
import UnitesList from '../Products/UnitesList';
import StockPage from '../Stock';
import BarcodePage from '../Stock/BarcodePage';
import EntrepotPage from '../Entrepot/EntrepotPage';
import LotPage from '../Products/LotPage';
import MouvementStockPage from '../Products/MouvementStockPage';

const InventoryModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: 'inventory',
    title: t('modules.inventory.title'),
    description: t('modules.inventory.description'),
    icon: FaBoxes,
    color: '#28a745',
    menuItems: [
      { path: '/inventory-module/entrepots', icon: FaWarehouse, label: t('nav.entrepots') },
      { path: '/inventory-module/categories', icon: FaBox, label: t('nav.categories') },
      { path: '/inventory-module/products', icon: FaListAlt, label: t('nav.articles') },
      { path: '/inventory-module/units', icon: FaBalanceScale, label: t('nav.unites') },
      { path: '/inventory-module/stock', icon: FaBoxes, label: t('nav.stock') },
      // { path: '/inventory-module/lots', icon: FaBoxes, label: t('nav.lots') },
      // { path: '/inventory-module/movements', icon: FaDirections, label: t('nav.mouvementStock') },
      // { path: '/inventory-module/barcodes', icon: FaBarcode, label: t('nav.barcodes') }
    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        <Route path="/" element={<Navigate to="/inventory-module/products" replace />} />
        <Route path="/entrepots" element={<EntrepotPage />} />
        <Route path="/categories" element={<CategorieList />} />
        <Route path="/products" element={<ProductList />} />
        <Route path="/products/new" element={<ProductForm />} />
        <Route path="/products/edit" element={<ProductForm />} />
        <Route path="/units" element={<UnitesList />} />
        <Route path="/stock" element={<StockPage />} />
        <Route path="/lots" element={<LotPage />} />
        <Route path="/movements" element={<MouvementStockPage />} />
        <Route path="/barcodes" element={<BarcodePage />} />
      </Routes>
    </ModuleLayout>
  );
};

export default InventoryModule;
